import { getQueryLocale } from '../../common/selectors/locale-selectors';
import { handleExperimentsResponse } from '../../common/store/experiments/experiments-actions';
import { handleTagCloudWidgetResponse } from '../aggregated-tag-cloud/actions';

export const fetchTagCloudWidgetInitialData =
  () =>
  async (dispatch, getState, { aggregatorRequest }) => {
    const langQuery = getQueryLocale(getState());
    const language = langQuery ? `&language=${langQuery}` : '';
    const { experiments, tagCloud } = await aggregatorRequest(
      `/v1/tag-cloud-widget/render-model?onlyWithPublishedPosts=true${language}`,
      {
        throwOnInvalidJson: true,
      },
    );

    await Promise.all([
      dispatch(handleExperimentsResponse(experiments)),
      dispatch(handleTagCloudWidgetResponse(tagCloud)),
    ]);
  };
